// extracted by mini-css-extract-plugin
module.exports = {"dialog":"markers-module__dialog___2WjvH","table":"markers-module__table___3df8c"};